// frontend-public/src/services/bookingService.js
// ============================================================
// Online Web Booking — public API client（Plan 090 / 086 Phase 1a.0）
//
// 包 apiService.apiRequest（isTest=true → 不帶 JWT，純公開呼叫）打三個公開端點：
//   GET  /api/public/r/:slug
//   GET  /api/public/r/:slug/availability?date&partySize
//   POST /api/public/r/:slug/reservations
//
// 非 2xx 時 apiRequest 會 throw，error.response.data 內含 { error, message, existing? }，
// 由 BookingPage 對應成中文訊息。
// ============================================================

import { apiRequest } from './apiService';

const getRestaurant = async (slug) => {
  const res = await apiRequest('get', `public/r/${encodeURIComponent(slug)}`, null, true);
  return res.data;
};

const getAvailability = async (slug, date, partySize) => {
  const qs = `date=${encodeURIComponent(date)}&partySize=${encodeURIComponent(partySize)}`;
  const res = await apiRequest('get', `public/r/${encodeURIComponent(slug)}/availability?${qs}`, null, true);
  return res.data;
};

const createReservation = async (slug, payload) => {
  const res = await apiRequest('post', `public/r/${encodeURIComponent(slug)}/reservations`, payload, true);
  return res.data;
};

// ── 自助管理（T-015）— 公開 /api/public/c/:token（isTest=true → 不帶 JWT）──
const getManage = async (token) => {
  const res = await apiRequest('get', `public/c/${encodeURIComponent(token)}`, null, true);
  return res.data;
};
const cancelManage = async (token) => {
  const res = await apiRequest('post', `public/c/${encodeURIComponent(token)}/cancel`, {}, true);
  return res.data;
};
const modifyManage = async (token, patch) => {
  const res = await apiRequest('patch', `public/c/${encodeURIComponent(token)}`, patch, true);
  return res.data;
};
const emailManageLink = async (token, email) => {
  const res = await apiRequest('post', `public/c/${encodeURIComponent(token)}/email`, { email }, true);
  return res.data;
};

// ── 外帶點餐（Plan 106）— 公開 /api/public/r/:slug/menu + /takeout/*（isTest=true → 不帶 JWT）──
const getTakeoutMenu = async (slug) => {
  const res = await apiRequest('get', `public/r/${encodeURIComponent(slug)}/menu?channel=takeout`, null, true);
  return res.data;
};
const getTakeoutSlots = async (slug, date) => {
  const res = await apiRequest('get', `public/r/${encodeURIComponent(slug)}/takeout/slots?date=${encodeURIComponent(date)}`, null, true);
  return res.data;
};
const createTakeoutOrder = async (slug, payload) => {
  const res = await apiRequest('post', `public/r/${encodeURIComponent(slug)}/takeout/orders`, payload, true);
  return res.data;
};

const bookingService = {
  getRestaurant, getAvailability, createReservation,
  getManage, cancelManage, modifyManage, emailManageLink,
  getTakeoutMenu, getTakeoutSlots, createTakeoutOrder
};
export default bookingService;
export {
  getRestaurant, getAvailability, createReservation, getManage, cancelManage, modifyManage, emailManageLink,
  getTakeoutMenu, getTakeoutSlots, createTakeoutOrder
};
